
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { UploadDetailesGetResponse, UploadDetailesResponse, UploadDetailesResponseDto } from '@gtpl/shared-models/hrms';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import appSettings from 'apps/services/config';
import { getManager, Repository } from 'typeorm';
import { UploadDetailesAdapter } from './Dto/upload.detailes.adapter';
import { UploadDetailesDto } from './Dto/upload.detailes.dto';
import { UploadDetailesEntity } from './Dto/upload.detailes.entity';

@Injectable()
export class UploadDetailesService {
    static createUploadDetailes(bodyStructure: UploadDetailesDto, arg1: boolean): UploadDetailesResponse | PromiseLike<UploadDetailesResponse> {
        throw new Error('Method not implemented.');
    }

    constructor(
        private adapter: UploadDetailesAdapter,
        @InjectRepository(UploadDetailesEntity)
        private usersRepository: Repository<UploadDetailesEntity>,
    ) { }

    async createUploadDetailes(DTO: UploadDetailesResponseDto): Promise<UploadDetailesResponse> {

        const convertdtotoentity: UploadDetailesEntity = await this.adapter.convertDtoToEntity(DTO);
        const save: UploadDetailesEntity = await this.usersRepository.save(convertdtotoentity);
        return new UploadDetailesResponse(true, 110235, " Created successfully", save)

    }


    // async getUploadDetailes(): Promise<UploadDetailesGetResponse> {
    //     const records = await this.usersRepository.find()
    //     if (!records.length) {

    //         throw new ErrorResponse(9998, "No Necords Found")
    //     }
    //     return new UploadDetailesGetResponse(true, 110236, "Fetched successfully", records)


    // }




    async getUploadDetailes(): Promise<UploadDetailesGetResponse> {
        const manager = getManager()
        const query =
            ' SELECT  employee_code AS employeeCode , employee_name  AS employeeName, gender AS gender, designation AS designation, department AS department, priority_one AS priorityOne, priority_two AS priorityTwo, employee_status AS employeeStatus, year_of_experience AS yearOfExperience, email_id AS emailId, mobile_number AS mobileNumber FROM ' + appSettings.hrms_db + '. employee_upload_details '
        const data = await manager.query(query);
        console.log(data);
        if (data.length > 0) {
            const respDtos = data.map(item => new UploadDetailesResponseDto(item.employeeCode, item.employeeName, item.gender, item.designation, item.department, item.priorityOne, item.priorityTwo, item.employeeStatus, item.yearOfExperience, item.emailId, item.mobileNumber));
            const response = new UploadDetailesGetResponse(true, 1122, 'Data retrived successfully', respDtos);
            return response;
        } else {
            return new UploadDetailesGetResponse(false, 11, 'Data not found');
        }

    }


}










